export default __webpack_public_path__ + "static/media/negotiation-black.7b25b10e.svg";